import { CustomDatePipe } from 'app/shared/pipes/custom-date.pipe';
import { ReadDocoonInboundFlowNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-docoon-inbound-flow-notification.view-model';
import { ReadExportAllNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-export-all-notification.view-model';
import { ReadJournalNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-journal-notification-view-model';
import { ReadNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-notification.view-model';
import { ReadPdfMergeNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-pdf-merge-notification.view-model';
import { ReadSpreadsheetDashboardNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-spreadsheet-dashboard-notification.view-model';
import { ReadSpreadsheetExportNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-spreadsheet-export-notification.view-model';
import { DocoonInboundFlowNotificationModelHelper } from '../job-notification-card/docoon-inbound-flow-notification-card/docoon-inbound-flow-notification.model.helper';
import { ExportAllNotificationModelHelper } from '../job-notification-card/export-all-notification-card/export-all-notification.model.helper';
import { JournalNotificationModelHelper } from '../job-notification-card/journal-notification-card/journal-notification.model.helper';
import { PdfMergeNotificationModelHelper } from '../job-notification-card/pdf-merge-notification-card/pdf-merge-notification.model.helper';
import { SpreadsheetDashboardNotificationCardModelHelper } from '../job-notification-card/spreadsheet-dashboard-notification-card/spreadsheet-dashboard-notification-card.model.helper';
import { SpreadsheetExportNotificationCardModelHelper } from '../job-notification-card/spreadsheet-export-notification-card/spreadsheet-export-notification-card.model.helper';
import { AbstractNotificationCardModel } from './abstract-notification-card.model';

export class AbstractNotificationCardModelHelper {
  public static fromViewModel(
    readNotificationViewModels: ReadNotificationViewModel[],
    customDatePipe: CustomDatePipe,
    laboratoryLegalIdentifierSchemeCode: string | null,
  ): Array<AbstractNotificationCardModel> {
    const notifications = new Array<AbstractNotificationCardModel>();
    readNotificationViewModels.forEach((readNotificationViewModel) => {
      const notification = this._createModel(readNotificationViewModel, customDatePipe, laboratoryLegalIdentifierSchemeCode);
      // A discriminator this client does not know yet (a newer server) has no card to render: skip it.
      if (notification) {
        notifications.push(notification);
      }
    });

    return notifications;
  }

  private static _createModel(
    readNotificationViewModel: ReadNotificationViewModel,
    customDatePipe: CustomDatePipe,
    laboratoryLegalIdentifierSchemeCode: string | null,
  ): AbstractNotificationCardModel | undefined {
    let notification: AbstractNotificationCardModel | undefined;

    if (readNotificationViewModel.discriminator === 'DocoonInboundFlow') {
      const readDocoonInboundFlowNotificationViewModel = readNotificationViewModel as ReadDocoonInboundFlowNotificationViewModel;
      notification = DocoonInboundFlowNotificationModelHelper.fromViewModelSingle(
        readDocoonInboundFlowNotificationViewModel,
        customDatePipe,
      );
    }
    if (readNotificationViewModel.discriminator === 'ExportAll') {
      const readExportAllNotificationViewModel = readNotificationViewModel as ReadExportAllNotificationViewModel;
      notification = ExportAllNotificationModelHelper.fromViewModelSingle(readExportAllNotificationViewModel, customDatePipe);
    }
    if (readNotificationViewModel.discriminator === 'Journal') {
      const readJournalNotificationViewModel = readNotificationViewModel as ReadJournalNotificationViewModel;
      notification = JournalNotificationModelHelper.fromViewModelSingle(readJournalNotificationViewModel, customDatePipe);
    }
    if (readNotificationViewModel.discriminator === 'PdfMerge') {
      const readPdfMergeNotificationViewModel = readNotificationViewModel as ReadPdfMergeNotificationViewModel;
      notification = PdfMergeNotificationModelHelper.fromViewModelSingle(
        readPdfMergeNotificationViewModel,
        customDatePipe,
        laboratoryLegalIdentifierSchemeCode,
      );
    }
    if (readNotificationViewModel.discriminator === 'SpreadsheetExport') {
      const readSpreadsheetExportNotificationViewModel = readNotificationViewModel as ReadSpreadsheetExportNotificationViewModel;
      notification = SpreadsheetExportNotificationCardModelHelper.fromViewModelSingle(
        readSpreadsheetExportNotificationViewModel,
        customDatePipe,
      );
    }
    if (readNotificationViewModel.discriminator === 'SpreadsheetDashboard') {
      const readSpreadsheetDashboardNotificationViewModel = readNotificationViewModel as ReadSpreadsheetDashboardNotificationViewModel;
      notification = SpreadsheetDashboardNotificationCardModelHelper.fromViewModelSingle(
        readSpreadsheetDashboardNotificationViewModel,
        customDatePipe,
      );
    }

    return notification;
  }
}
